import axios from "../../interceptors/axiosInterceptor";
import {
  FETCH_CATEGORY_LIST_FOR_CITY_URL,
  FETCH_CATEGORY_PRODUCTS_FOR_CITY_URL,
  GET_BULK_PRODUCTS_BY_CATEGORY_IDS,
  GET_CATEGORY_LIST_URL,
  REORDER_CATEGORY_PRODUCTS_FOR_CITY,
  UPDATE_CITY_LEVEL_CATEGORY_URL,
  UPLOAD_IMAGE_URL,
} from "../../config/Url";
import {
  ICategoryCityLevelPayload,
  ICategoryListingResponseAction,
  ICategoryProductsResponse,
  ICategoryProductUpdatePayload,
  ICreateCategoryPayload,
  IGetQueryParams,
  IIdsPayload,
  IProductDetailsResponse,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
  normalizeCategoryCityListingResponse,
  normalizeCategoryListing,
  normalizeProductDetailPageCategoryListing,
} from "../../normalizer/CategoryNormalizer";
import { SOMETHING_WENT_WRONG } from "../../config/constants";

export const getCategoriesApiCall = (
  queryParam: IGetQueryParams = {},
  isProductDetailPage: boolean = false
) =>
  new Promise<ICategoryListingResponseAction>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_CATEGORY_LIST_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response.data;
          const pageNumber = queryParam.page ? Number(queryParam.page) + 1 : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 50
              ? true
              : false;
          resolve(
            isProductDetailPage
              ? normalizeProductDetailPageCategoryListing(
                data,
                pageNumber,
                isPaginatedRes
              )
              : normalizeCategoryListing(data, pageNumber, isPaginatedRes)
          );
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateCityLevelCategoryApiCall = (
  categoryId: string,
  cityId: string,
  payload: ICategoryCityLevelPayload
) =>
  new Promise<void>((resolve, reject) => {
    const url = UPDATE_CITY_LEVEL_CATEGORY_URL.replace(
      "{categoryId}",
      categoryId
    ).replace("{cityId}", cityId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (!response)
          reject({
            errors:
              "Error updating Category[" +
              categoryId +
              "] for City=[" +
              cityId +
              "]",
          });
        resolve();
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });

export const reorderCategoryProductsForCityApiCall = (
  categoryId: string,
  cityId: string,
  payload: ICategoryProductUpdatePayload
) =>
  new Promise<void>((resolve, reject) => {
    let url = REORDER_CATEGORY_PRODUCTS_FOR_CITY.replace(
      "{categoryId}",
      categoryId
    ).replace("{cityId}", cityId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (!response)
          reject({
            errors:
              "Error reordering Category Products for Category=[" +
              categoryId +
              "], City=[" +
              cityId +
              "]",
          });
        resolve();
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });

export const getBulkProductByCategoryIds = (payload: IIdsPayload) =>
  new Promise<IProductDetailsResponse[]>((resolve, reject) => {
    axios
      .post(GET_BULK_PRODUCTS_BY_CATEGORY_IDS, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(data);
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchCategoriesForCityApiCall = (
  cityId: string,
  queryParam: IGetQueryParams = {}
) =>
  new Promise<ICategoryListingResponseAction>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(
        FETCH_CATEGORY_LIST_FOR_CITY_URL.replace("{cityId}", cityId),
        requestConfig
      )
      .then((response) => {
        if (!response)
          reject({
            errors: "Error fetching Categories for City=[" + cityId + "]",
          });
        const pageNumber = queryParam.page ? Number(queryParam.page) + 1 : 1;
        const isPaginatedRes = !!(
          queryParam.page &&
          (queryParam.page as any) > 0 &&
          response.data.length >= 50
        );
        resolve(
          normalizeCategoryCityListingResponse(
            response.data.categories,
            pageNumber,
            isPaginatedRes
          )
        );
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });

export const fetchCategoryProductsForCityApiCall = (
  categoryId: string,
  cityId: string,
  queryParam: IGetQueryParams = {}
) =>
  new Promise<Array<ICategoryProductsResponse>>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(
        FETCH_CATEGORY_PRODUCTS_FOR_CITY_URL.replace(
          "{categoryId}",
          categoryId
        ).replace("{cityId}", cityId),
        requestConfig
      )
      .then((response) => {
        if (!response)
          reject({
            errors:
              "Error fetching Category Products for Category=[" +
              categoryId +
              "], City=[" +
              cityId +
              "]",
          });
        resolve(response.data);
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });
